import { joinPaths } from '@pop-common/helper/utils/join-paths';

import { getOrgId } from '../local-ids/get-org-id';

import { GetCollectionRefInput } from './get-collection-ref';

export interface GetDocPathInput extends GetCollectionRefInput {
  id: string;
}

export const getDocPath = async ({ Deserializer, id }: GetDocPathInput) => {
  const orgId = await getOrgId();
  const collectionPath = Deserializer.getSchema().getCollection(orgId);

  return joinPaths(collectionPath, id);
};
